import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, switchMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import ProductsAttributesReceived from '../events/ProductsAttributesReceived';
import OrderPageEntered from '../events/OrderPageEntered';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> => {
    return event$.pipe(
        ofType(OrderPageEntered.type),
        switchMap(() => {
            return backend.get(`${api()}product-attributes`).pipe(
                map((ajaxResponse: AjaxResponse) => new ProductsAttributesReceived(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            );
        })
    );
};



// WEBPACK FOOTER //
// ./src/application/products/epic/getAttributes.ts